import React, {FC} from "react";
import isEmpty from "lodash/isEmpty";
import {GridItem} from "@/widget/GridItem/GridItem";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import Stack from "@mui/material/Stack";
import {LinearProgress, Grid} from "@mui/material";
import {isNumber} from "lodash";
import {checkQueryKey, formatTime, getRealId, getSellerNames} from "@/helper/method";
import {ModeType, useDialogModal, useDrawerModal} from "@/store/global.c";
import {useQueryChance} from "@/service/chance.s";
import Typography from "@mui/material/Typography";

interface ViewChanceProps {
    mode: ModeType;
}

export const ViewChance: FC<ViewChanceProps> = ({mode}) => {
    const {id: drawerId} = useDrawerModal()
    const {id: dialogId} = useDialogModal()
    const id = getRealId(mode, drawerId, dialogId);
    const {data: chanceData, isLoading: chanceLoading} = useQueryChance({id}, isNumber(id))
    const chance = chanceData?.data

    return <ResultWrapper isLoading={chanceLoading} isEmpty={isEmpty(chance)}>
        <Stack direction={'column'} width={'100%'} gap={2}>
            <Grid spacing={3} container>
                <GridItem title={'客户名称'} content={chance?.customerName}/>
                <GridItem title={'商机名称'} content={chance?.kind}/>
                <GridItem title={'服务类型'} content={chance?.category}/>
                <GridItem title={'业务人员'} content={getSellerNames(chance?.creator, chance?.seller)}/>
                <GridItem title={'商机阶段'} content={chance?.stage}/>
                <GridItem title={'商机金额'} content={chance?.money}/>
                <GridItem title={'数量'} content={chance?.amount}/>
                <GridItem title={'成交概率'} alignContent={'space-around'} minHeight={31}
                          content={<Grid container={true} direction={'row'} justifyContent={'space-between'} alignItems={'center'} alignContent={'center'}>
                              <Grid size={10}>
                                  <LinearProgress variant="determinate" value={chance?.dealRate}/>
                              </Grid><Typography>{chance?.dealRate}%</Typography></Grid>}/>
                <GridItem title={'预计成交时间'} content={formatTime('D', chance?.dealDate)}/>
                <GridItem title={'是否转化'}
                          content={checkQueryKey(chance?.contractId) ? <Typography color={'success'}>已转化</Typography> : <Typography color={'warning'}>未转化</Typography>}/>
                <GridItem minHeight={'48px'} size={12} title={'备注'} content={chance?.remark || '-'}/>

                <GridItem title={'更新时间'} content={formatTime('D', chance?.updatedAt)}/>
                <GridItem title={'创建时间'} content={formatTime('D', chance?.createdAt)}/>
            </Grid>
        </Stack>
    </ResultWrapper>
}